
import {Component, Prop, Vue} from 'vue-property-decorator';
import router from '../router';
import {api} from '../Api';

    @Component({})
    export default class CountrySelector extends Vue {
        show = false;

        @Prop()
        public general;

        trans(str: string){
            return str;
        }

        hide() {
            this.show = false
        }
        mounted(): void {
            if (!localStorage.getItem('zone')) {
                this.show = true
            }
        }
        selectZone(tenant: any){
            this.$store.commit('setTenant', tenant);
            this.setZone(router.resolve({name: 'home'}).href);
        }

        setZone(location: string|null) {
            const cookieValue = JSON.stringify(this.$store.state.tenant);
            localStorage.setItem('zone',  cookieValue);

            api.setCookie('zone', cookieValue, 60);
            this.show = false
            if(location === null){
                window.location.reload()
            }else{
                window.location.assign(location);
            }

        }

        // setCookie(cname: string, cvalue: string, exdays = 1) {
        //     const d = new Date();
        //     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        //     let expires = "expires=" + d.toUTCString();
        //     document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.wia.ci;path=/";
        // }

    }
